import React from 'react';
import Base, { Breadcrumbs } from './../layout';
const Dashboard = () => (
    <Base>
        <Breadcrumbs title="Dashboard" />
    </Base>
);
export default Dashboard;
